import styled from 'vue3-styled-components';

export const PageContainer = styled.div`
`;

// 새로운 레이아웃 스타일 추가
export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 30px;
  
  @media (max-width: 1400px) {
    gap: 25px;
    margin-left: 20px;
    margin-right: 20px;
  }
  
  @media (max-width: 1200px) {
    gap: 20px;
    margin-top: 30px;
    margin-left: 15px;
    margin-right: 15px;
  }
  
  @media (max-width: 768px) {
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    margin: 15px 8px;
    gap: 12px;
  }
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  
  @media (max-width: 1400px) {
    gap: 25px;
  }
  
  @media (max-width: 1200px) {
    gap: 20px;
  }
  
  @media (max-width: 768px) {
    gap: 15px;
  }
  
  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const ClaimsTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  
  @media (max-width: 1400px) {
    font-size: 22px;
    gap: 10px;
  }
  
  @media (max-width: 768px) {
    font-size: 20px;
    gap: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: 18px;
    gap: 6px;
  }
`;

export const ClaimsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 1400px) {
    margin-bottom: 20px;
    gap: 14px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 18px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
    margin-bottom: 16px;
  }
`;

export const ClaimsActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 1400px) {
    gap: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    gap: 8px;
  }
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 6px;
  }
`;

// 청구 내역 카드
export const ClaimsCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 8px 25px -5px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 30px;
    
  /* 웹킷 기반 브라우저 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
    margin: 4px 0;
  }
  
  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #cbd5e1, #94a3b8);
    border-radius: 10px;
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;
    
    &:hover {
      background: linear-gradient(135deg, #94a3b8, #64748b);
      transform: scale(1.05);
    }
    
    &:active {
      background: linear-gradient(135deg, #64748b, #475569);
    }
  }
  
  &::-webkit-scrollbar-corner {
    background: #f1f5f9;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 35px -10px rgba(0, 0, 0, 0.15);
  }
  
  @media (max-width: 1400px) {
    padding: 24px;
    border-radius: 14px;
    max-height: 450px;
  }
  
  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 12px;
    max-height: 400px;
  }
  
  @media (max-width: 480px) {
    padding: 16px;
    border-radius: 10px;
    max-height: 350px;
  }
`;

// 통계 카드 - 공간 최적화
export const StatsCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    padding: 16px;
    margin-bottom: 16px;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

export const StatsItem = styled.div`
  text-align: center;
  padding: 16px 12px;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  
  &.processing-item {
    background: linear-gradient(135deg, #fef3c7, #fde68a);
    border-color: #f59e0b;
  }
  
  &.selected {
    border: 2px solid #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    padding: 12px 8px;
  }
`;

export const StatsValue = styled.div`
  font-size: 20px;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 4px;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const StatsLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

// 진행 중인 환자 표시
export const ProcessingPatient = styled.span`
  display: inline-block;
  padding: 4px 8px;
  background: #3b82f6;
  color: white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 3px 6px;
  }
`;

export const OxygenAutomationSection = styled.section`
  margin-bottom: 10px;
`;

export const DiabetesAutomationSection = styled.section`
  margin-bottom: 10px;
`;

// 통계 섹션
export const StatsSection = styled.section`
  margin-bottom: 20px;
`;

// 검색 섹션
export const SearchSection = styled.section`
  margin-bottom: 30px;
`;

export const SearchRow = styled.div`
  display: flex;
  gap: 20px;
  align-items: end;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

// 환자 정보 섹션
export const PatientSection = styled.section`
  margin-bottom: 30px;
`;

// 청구 내역 섹션
export const ClaimsSection = styled.section`
  margin-bottom: 30px;
`;

// * ====================================================
// * 청구 자동화 섹션 스타일
// * =====================================================
export const AutomationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 10px;
  }
`;

export const AutomationTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const AutomationTitle = styled.h3`
  font-size: 28px;
  font-weight: 800;
  color: #1a202c;
  margin: 0;
  background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  
  @media (max-width: 1400px) {
    font-size: 24px;
  }
  
  @media (max-width: 768px) {
    font-size: 22px;
  }
  
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const AutomationSubtitle = styled.p`
  font-size: 16px;
  color: #64748b;
  margin: 0;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const AutomationActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const AutomationStatusBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  border: 2px solid #e2e8f0;

  &:hover {
    transform: translateY(-3px);
  }
  
  &.active {
    background: #f8fafc;
    color: #10b981;
    border-color: #10b981;
  }

  &.stopping {
    background: #f8fafc;
    color: #dc2626;
    border-color: #dc2626;
  }
  
  @media (max-width: 768px) {
    padding: 10px 16px;
    font-size: 13px;
  }
`;

export const StatusIcon = styled.span`
  font-size: 16px;
`;

export const AutomationTabs = styled.div`
  display: flex;
  border-bottom: 2px solid #f1f5f9;
  margin-bottom: 24px;
  gap: 4px;
  
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 2px;
  }
`;

export const TabIcon = styled.span`
  font-size: 18px;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const AutomationContent = styled.div`
  margin-top: 20px;
`;

// 테이블
export const ClaimsTable = styled.table`
  width: 100%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;

  &.delegation-table {
    th:nth-child(1) { width: 6%; }   // 처리상태
    th:nth-child(2) { width: 8%; }   // 처리지사
    th:nth-child(3) { width: 9%; }   // 접수일자
    th:nth-child(4) { width: 11%; }  // 수진자주민번호
    th:nth-child(5) { width: 6%; }   // 수진자명
    th:nth-child(6) { width: 10%; }  // 요양비종류
    th:nth-child(7) { width: 11%; }  // 위임동의기간
    th:nth-child(8) { width: 12%; }  // 보류(반려)사유
    th:nth-child(9) { width: 13%; }  // 금융정보
    th:nth-child(10) { width: 10%; } // 연락처
  }

  &.oxygen-table {
    th:nth-child(1) { width: 5%; }   // 지급상태
    th:nth-child(2) { width: 6%; }   // 거래일시
    th:nth-child(3) { width: 5%; }   // 거래기록사항
    th:nth-child(4) { width: 6%; }   // 처리상태
    th:nth-child(5) { width: 6%; }   // 접수일자
    th:nth-child(6) { width: 6%; }   // 수진자명
    th:nth-child(7) { width: 8%; }  // 사용기간
    th:nth-child(8) { width: 7%; }  // 지급금액
    th:nth-child(9) { width: 10%; }  // 지급취소/반송사유
    th:nth-child(10) { width: 7%; }  // 최종지급일
    th:nth-child(11) { width: 7%; } // 사업자명
  }

  &.assistance-table {
    th:nth-child(1) { width: 8%; }   // 처리상태
    th:nth-child(2) { width: 9%; }   // 접수일자
    th:nth-child(3) { width: 12%; }  // 보조기기 품목
    th:nth-child(4) { width: 6%; }   // 수급자
    th:nth-child(5) { width: 12%; }  // 주민등록번호
    th:nth-child(6) { width: 9%; }   // 지급금액
    th:nth-child(7) { width: 10%; }  // 취소/반송 사유
    th:nth-child(8) { width: 8%; }   // 지급일자
    th:nth-child(9) { width: 10%; }  // 판매업체명
    th:nth-child(10) { width: 8%; }  // 관할지사
  }
  
  @media (max-width: 1200px) {
    border-radius: 10px;
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    border-radius: 8px;
    font-size: 12px;
    
    &.delegation-table,
    &.assistance-table {
      th:nth-child(n) { width: auto; }
    }
  }
  
  @media (max-width: 480px) {
    border-radius: 6px;
    font-size: 11px;
  }
`;

export const ClaimsTableHeader = styled.thead`
  background: #f8fafc;
`;

export const ClaimsTableBody = styled.tbody``;

export const ClaimsTableRow = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #e2e8f0;
  }
  
  &:hover {
    background: #f8fafc;
  }
`;

export const ClaimsTableHeaderCell = styled.th`
  padding: 16px;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  border-bottom: 2px solid #e2e8f0;
  
  @media (max-width: 1400px) {
    padding: 14px;
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    padding: 10px;
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
    font-size: 11px;
  }
`;

export const AutomationTableHeaderCell = styled.th`
  padding: 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  border-bottom: 2px solid #e2e8f0;
  
  @media (max-width: 1400px) {
    padding: 14px;
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    padding: 10px;
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
    font-size: 11px;
  }
`;

export const AutomationTableCell = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #2d3748;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  
  @media (max-width: 1400px) {
    padding: 14px;
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    padding: 10px;
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
    font-size: 11px;
  }
`;

export const ClaimsTableCell = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #2d3748;
  vertical-align: middle;
  
  @media (max-width: 1400px) {
    padding: 14px;
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    padding: 10px;
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px;
    font-size: 11px;
  }
`;

// 배지
export const ClaimTypeBadge = styled.span`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  
  &.diabetes {
    background: #dbeafe;
    color: #1e40af;
  }
  
  &.oxygen {
    background: #ecfdf5;
    color: #065f46;
  }
  
  &.assistance {
    background: #fef3c7;
    color: #92400e;
  }
`;

export const ClaimStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  transition: all 0.2s ease;

  &.claim-status-0 {
    background-color: #fef3c7;
    color: #92400e;
    border: 1px solid #fbbf24;
  }

  &.claim-status-1 {
    background-color: #dbeafe;
    color: #1e40af;
    border: 1px solid #3b82f6;
  }

  &.claim-status-2 {
    background-color: #e0e7ff;
    color: #3730a3;
    border: 1px solid #6366f1;
  }

  &.claim-status-3 {
    background-color: #ffe4e6;
    color: #be123c;
    border: 1px solid #fb7185;
  }

  &.claim-status-completed {
    background-color: #d1fae5;
    color: #065f46;
    border: 1px solid #10b981;
    font-weight: 700;
  }

  &.claim-status-default {
    background-color: #f3f4f6;
    color: #6b7280;
    border: 1px solid #d1d5db;
  }
`;

// 액션 버튼
export const ActionButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionIcon = styled.span`
  font-size: 14px;
`;

// 환자 상태 클래스 추가
export const PatientStatusClass = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  
  &.status-active {
    background: #dcfce7;
    color: #166534;
  }
  
  &.status-inactive {
    background: #f3f4f6;
    color: #6b7280;
  }
  
  &.status-processing {
    background: #dbeafe;
    color: #1e40af;
  }
  
  &.status-error {
    background: #fee2e2;
    color: #dc2626;
  }
`;

// 청구 상태 클래스 추가
export const ClaimStatusClass = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  
  &.status-pending {
    background: #fef3c7;
    color: #92400e;
  }
  
  &.status-processing {
    background: #dbeafe;
    color: #1e40af;
  }
  
  &.status-completed {
    background: #dcfce7;
    color: #166534;
  }
  
  &.status-failed {
    background: #fee2e2;
    color: #dc2626;
  }
  
  &.status-ready {
    background: #e0f2fe;
    color: #0369a1;
  }
`;

// 당뇨 유형 스타일
export const DiabetesType = styled.span`
  font-weight: 500;
  color: #1f2937;
  font-size: 14px;
  padding: 4px 8px;
  background: #fef3c7;
  border-radius: 6px;
  display: inline-block;
`;

export const InsulinType = styled.span`
  font-weight: 500;
  color: #1f2937;
  font-size: 14px;
  padding: 4px 8px;
  background: #dbeafe;
  border-radius: 6px;
  display: inline-block;
`;

// 날짜 값 스타일
export const ValidityDateValue = styled.span`
  font-size: 12px;
  color: #374151;
  font-weight: 500;
  min-width: 80px;
  display: block;
`;

// 검색 결과 없음
export const NoResultSection = styled.section`
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
`;

export const NoResultIcon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.6;
`;

export const NoResultTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #4a5568;
  margin: 0 0 12px 0;
`;

export const NoResultDescription = styled.p`
  font-size: 16px;
  color: #718096;
  margin: 0;
  line-height: 1.6;
`;

// 반응형 미디어 쿼리 추가
export const ResponsiveContainer = styled.div`
  @media (max-width: 1024px) {
    ${PageContainer} {
      padding: 15px;
    }
    
    ${SearchRow} {
      flex-direction: column;
      align-items: stretch;
    }
    
    ${ClaimsHeader} {
      flex-direction: column;
      align-items: flex-start;
    }
    
    ${ClaimsActions} {
      width: 100%;
      justify-content: space-between;
    }
  }
  
  @media (max-width: 768px) {
    ${StatsGrid} {
      grid-template-columns: repeat(2, 1fr);
    }
    
    ${ActionButtonGroup} {
      flex-wrap: wrap;
    }
  }
  
  @media (max-width: 480px) {
    ${StatsGrid} {
      grid-template-columns: 1fr;
    }
    
    ${ClaimsTable} {
      font-size: 12px;
    }
    
    ${ClaimsTableHeaderCell}, ${ClaimsTableCell} {
      padding: 8px;
    }
  }
`;

// 로딩 상태
export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #f3f4f6;
  border-radius: 50%;
  border-top-color: #3b82f6;
  animation: spin 1s ease-in-out infinite;
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

// 성공/에러 메시지
export const AlertMessage = styled.div`
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  
  &.success {
    background: #dcfce7;
    color: #166534;
    border: 1px solid #bbf7d0;
  }
  
  &.error {
    background: #fecaca;
    color: #dc2626;
    border: 1px solid #fca5a5;
  }
  
  &.warning {
    background: #fef3c7;
    color: #92400e;
    border: 1px solid #fde68a;
  }
  
  &.info {
    background: #dbeafe;
    color: #1e40af;
    border: 1px solid #93c5fd;
  }
`;

// 툴팁
export const Tooltip = styled.div`
  position: absolute;
  background: #1a202c;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1001;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  
  &.visible {
    opacity: 1;
    visibility: visible;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border: 5px solid transparent;
    border-top-color: #1a202c;
  }
`;

// 드롭다운 메뉴
export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: 160px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.2s;
  
  &.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;

export const DropdownItem = styled.button`
  width: 100%;
  padding: 10px 16px;
  text-align: left;
  background: none;
  border: none;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: #f9fafb;
  }
  
  &:first-child {
    border-radius: 8px 8px 0 0;
  }
  
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
  
  &.danger {
    color: #dc2626;
    
    &:hover {
      background: #fef2f2;
    }
  }
`;

// 테이블 정렬 헤더
export const SortableHeader = styled(ClaimsTableHeaderCell)`
  cursor: pointer;
  user-select: none;
  position: relative;
  
  &:hover {
    background: #f1f5f9;
  }
  
  &::after {
    content: '';
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    opacity: 0.3;
  }
  
  &.asc::after {
    border-bottom: 6px solid #64748b;
    opacity: 1;
  }
  
  &.desc::after {
    border-top: 6px solid #64748b;
    opacity: 1;
  }
`;

// 검색 하이라이트
export const SearchHighlight = styled.span`
  background: #fef3c7;
  color: #92400e;
  padding: 1px 2px;
  border-radius: 2px;
`;

// 카드 애니메이션
export const AnimatedCard = styled.div`
  animation: slideInUp 0.3s ease-out;
  
  @keyframes slideInUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

// 페이지네이션
export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
`;

export const PaginationButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #64748b;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  
  &:hover:not(:disabled) {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
  
  &.active {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PaginationInfo = styled.span`
  font-size: 14px;
  color: #64748b;
  margin: 0 16px;
`;

export const FilesTabs = styled.div`
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 16px;
`;

export const ClaimsTabs = styled.div`
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 16px;
`;

export const TabButton = styled.button`
  padding: 12px 24px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;

  &:hover {
    color: #333;
    background-color: #f5f5f5;
  }

  &.active {
    color: #0f4c5c;
    border-bottom-color: #0f4c5c;
    font-weight: 600;
  }
  
  @media (max-width: 1400px) {
    padding: 10px 20px;
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 6px 12px;
    font-size: 11px;
  }
`;

// =====================================================
// 크롤링 진행률 표시 스타일
// =====================================================
// 크롤링 중 버튼 비활성화 스타일
export const CrawlingDisabledButton = styled.button`
    opacity: 0.6;
    cursor: not-allowed;
    
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

// =====================================================
// 날짜 선택 스타일
// =====================================================

export const DateSelectionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 6px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    gap: 4px;
  }
`;

export const DateInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #374151;
  background-color: #ffffff;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  &:hover {
    border-color: #9ca3af;
  }
  
  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.2s ease;
  }
  
  &::-webkit-calendar-picker-indicator:hover {
    opacity: 1;
  }
  
  @media (max-width: 1400px) {
    padding: 7px 10px;
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    padding: 6px 8px;
    font-size: 12px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 5px 6px;
    font-size: 11px;
  }
`;

export const DateSeparator = styled.span`
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
`;

// =====================================================
// 크롤링된 청구 내역 테이블 스타일
// =====================================================

// 상태 배지
export const StatusBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  
  &.status-processing {
    background: #dbeafe;
    color: #1e40af;
  }
  
  &.status-completed {
    background: #dcfce7;
    color: #166534;
  }
  
  &.status-rejected {
    background: #fee2e2;
    color: #dc2626;
  }
  
  &.status-cancelled {
    background: #f3e8ff;
    color: #7c3aed;
  }
  
  &.status-default {
    background: #f3f4f6;
    color: #6b7280;
  }
`;

// 요양비종류 배지
export const BenefitTypeBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  &.type-oxygen {
    background: #ecfdf5;
    color: #065f46;
  }
  
  &.type-diabetes {
    background: #ede9fe;
    color: #7c3aed;
  }
  
  &.type-assistance {
    background: #fef3c7;
    color: #92400e;
  }
  
  &.type-default {
    background: #f3f4f6;
    color: #6b7280;
  }
`;

// 날짜 표시
export const DateDisplay = styled.span`
  font-size: 13px;
  color: #374151;
  font-weight: 500;
`;

// 수진자 정보
export const PatientInfo2 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PatientName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
`;

export const PatientNumber = styled.span`
  font-size: 12px;
  color: #6b7280;
  font-family: 'Courier New', monospace;
`;

// 날짜 범위
export const DateRange = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DateItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const DateLabel = styled.span`
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
  min-width: 20px;
`;

export const DateValue = styled.span`
  font-size: 12px;
  color: #374151;
  font-weight: 500;
`;

// 금액 표시
export const AmountDisplay = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #059669;
  font-family: 'Courier New', monospace;
`;

// 사업자 정보
export const BusinessInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BusinessName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
`;

export const BusinessNumber = styled.span`
  font-size: 12px;
  color: #6b7280;
  font-family: 'Courier New', monospace;
`;

export const FinancialInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const FinancialItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
`;

export const FinancialLabel = styled.span`
  font-weight: 600;
  color: #666;
  min-width: 40px;
`;

export const FinancialValue = styled.span`
  color: #333;
  word-break: break-all;
`;

// 청구 자동화 관련 추가 스타일
export const ClaimListButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 15px;
  background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  margin-left: 10px;
  
  &:hover {
    background: linear-gradient(135deg, #1a6b7a 0%, #0f4c5c 100%);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(1px);
  }
`;

// 환자명 검색 관련 스타일드 컴포넌트
export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 12px;
  
  @media (max-width: 768px) {
    margin-left: 8px;
    width: 100%;
    margin-top: 8px;
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 10px;
  z-index: 1;
  display: flex;
  align-items: center;
  color: #6b7280;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  padding: 10px 36px 10px 36px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  width: 200px;
  outline: none;
  background-color: white;
  
  &:hover {
    border-color: #9ca3af;
  }
  
  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  &::placeholder {
    color: #9ca3af;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    font-size: 13px;
    padding: 6px 32px 6px 32px;
  }
  
  @media (max-width: 480px) {
    width: 100%;
    font-size: 12px;
    padding: 6px 28px 6px 28px;
  }
`;

export const ClearSearchButton = styled.button`
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #6b7280;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #374151;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
    right: 6px;
  }
`;

export const AddClaimButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 15px;
  background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: linear-gradient(135deg, #1a6b7a 0%, #0f4c5c 100%);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(1px);
  }
  
  @media (max-width: 1400px) {
    padding: 4px 12px;
    font-size: 13px;
    border-radius: 7px;
  }
  
  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 6px;
    flex: 1;
    justify-content: center;
  }
  
  @media (max-width: 480px) {
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 5px;
  }
`;

export const FilterSelect = styled.select`
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
  }
  
  @media (max-width: 1400px) {
    padding: 7px 10px;
    font-size: 13px;
  }
  
  @media (max-width: 768px) {
    padding: 6px 8px;
    font-size: 12px;
    width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 5px 6px;
    font-size: 11px;
  }
`;

export const ButtonIcon = styled.span`
  font-size: 18px;
`;

// 유효기간 컨테이너
export const ValidityPeriodContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
`;

// 유효기간 입력 그룹
export const ValidityInputGroup = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

// 유효기간 라벨
export const ValidityLabel = styled.label`
  font-size: 12px;
  color: #666;
  min-width: 40px;
  font-weight: 500;
`;

// 유효기간 날짜 입력 필드
export const ValidityDateInput = styled.input`
  width: 120px;
  padding: 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #fb8b24;
    box-shadow: 0 0 0 2px rgba(251, 139, 36, 0.2);
  }
  
  &:hover {
    border-color: #fb8b24;
  }
`;

// * ====================================================
// * 상단 섹션 스타일
// * =====================================================
// 상단 섹션 (청구 자동화 + 청구 일정)
export const TopSection = styled.div`
  display: flex;
  gap: 20px;
  
  @media (max-width: 1400px) {
    gap: 16px;
  }
  
  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 20px;
  }
  
  @media (max-width: 768px) {
    gap: 16px;
  }
`;

// 왼쪽 청구 자동화 섹션
export const LeftAutomationSection = styled.div`
  flex: 1;
  min-width: 0;
`;

// 오른쪽 청구 일정 섹션
export const RightScheduleSection = styled.div`
  flex: 0.6;
  min-width: 0;
`;

// 청구 일정 관련 스타일
export const ScheduleCount = styled.span`
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  margin-left: 8px;
`;

// 달력 섹션
export const CalendarSection = styled.div`
  margin-bottom: 20px;
  overflow: visible;
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const CalendarNavigation = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CalendarButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #64748b;
  
  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
  
  &:active {
    background: #f1f5f9;
  }
`;

export const CalendarTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  min-width: 120px;
  text-align: center;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  background: #e2e8f0;
  border-radius: 8px;
  overflow: visible;
`;

export const CalendarDayHeader = styled.div`
  background: #f8fafc;
  padding: 12px 8px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;

  &.sunday {
    color: #dc2626; /* 빨간색 */
  }

  &.saturday {
    color: #2563eb; /* 파란색 */
  }
`;

export const CalendarDay = styled.div`
  background: white;
  min-height: 80px;
  padding: 8px;
  cursor: pointer;
  position: relative;

  &:hover {
    background: #f9fafb;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &.other-month {
    background: #f9fafb;
    color: #9ca3af;
  }

  &.today {
    background: #eff6ff;
    border: 2px solid #3b82f6;
  }

  &.has-events {
    background: #fef3c7;
  }

  &.selected {
    background: #dbeafe;
    border: 2px solid #3b82f6;
  }

  @media (max-width: 768px) {
    min-height: 60px;
    padding: 4px;
  }
`;

export const CalendarDayNumber = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
`;

export const CalendarDayEvents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CalendarEvent = styled.div`
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 3px;
  color: white;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.oxygen {
    background: #3b82f6;
  }

  &.diabetes {
    background: #7b1fa2;
  }

  &.expired {
    background: #c62828 !important;
  }

  &.completed {
    opacity: 0.6;
    background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%) !important;
    border: 1px solid #2e7d32;
  }

  @media (max-width: 768px) {
    font-size: 9px;
    padding: 1px 4px;
  }
`;

export const CalendarMoreEvents = styled.div`
  margin-top: 3px;
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  font-weight: 500;
`;

// 실패한 환자들 컨테이너
export const FailedPatientsContainer = styled.div`
    text-align: left;
`;

// 실패한 환자 아이템
export const FailedPatientItem = styled.div`
    margin-bottom: 4px;
    padding: 2px 0;
`;

// 실패 사유
export const FailedReason = styled.div`
    font-size: 11px;
    color: #6b7280;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
`;

// 더 많은 실패 환자 표시
export const MoreFailedPatients = styled.div`
    font-size: 11px;
    color: #6b7280;
    font-style: italic;
    margin-top: 2px;
`;

// 진행 중 환자 컨테이너 (기존 ProcessingPatient 수정)
export const ProcessingPatientContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

// 실패 카드 스타일 (기존 StatsItem 확장)
export const FailedStatsItem = styled(StatsItem)`
    &.selected {
        background-color: #fef2f2;
        border-color: #fecaca;
    }
    
    &:hover {
        background-color: #fef2f2;
    }
`;

// 진행 중 카드 스타일 (기존 StatsItem 확장)
export const ProcessingStatsItem = styled(StatsItem)`
    &.selected {
        background-color: #f0fdf4;
        border-color: #bbf7d0;
    }
    
    &:hover {
        background-color: #f0fdf4;
    }
`;

// 실패 카드 개수 표시
export const FailedCount = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: #dc2626;
    margin-bottom: 4px;
`;

// 실패한 환자 정보 컨테이너
export const FailedPatientInfo = styled.div`
    text-align: left;
`;

// 실패한 행 스타일
export const FailedRow = styled(ClaimsTableRow)`
    background-color: #fef2f2;
    border-left: 4px solid #dc2626;
    
    &:hover {
        background-color: #fef2f2;
    }
`;

// 실패 에러 정보 컨테이너
export const FailedErrorInfo = styled.div`
    text-align: left;
`;

// 실패한 환자 사유 (테이블용)
export const FailedPatientReason = styled.span`
    font-size: 11px;
    color: #6b7280;
    margin-top: 2px;
    display: block;
`;

// 실패한 환자 시간 (테이블용)
export const FailedPatientTime = styled.span`
    font-size: 10px;
    color: #9ca3af;
    margin-top: 1px;
    display: block;
`;

// 실패한 환자 카드 내부 컨테이너
export const FailedPatientsCard = styled.div`
    text-align: left;
`;

// 실패한 환자 아이템 (카드용)
export const FailedPatientCardItem = styled.div`
    margin-bottom: 4px;
    padding: 2px 0;
`;

// 실패한 환자 이름 (카드용)
export const FailedPatientCardName = styled.div`
    font-weight: 600;
    color: #dc2626;
    font-size: 13px;
`;

// 실패한 환자 사유 (카드용)
export const FailedPatientCardReason = styled.div`
    font-size: 11px;
    color: #6b7280;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
`;

// 진행 중 상태 표시
export const ProcessingStatus = styled.div`
    font-size: 12px;
    color: #10b981;
    font-weight: 500;
    margin-top: 2px;
`;

// 테이블 푸터
export const ClaimsTableFooter = styled.tfoot`
    background-color: #f8fafc;
`;

// 실패 로그 헤더
export const FailedLogHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #fecaca;
`;

// 실패 로그 제목
export const FailedLogTitle = styled.span`
    font-weight: 600;
    color: #374151;
    font-size: 14px;
`;

// 실패 로그 액션 버튼들
export const FailedLogActions = styled.div`
    display: flex;
    gap: 8px;
`;

// 전체 삭제 버튼
export const ClearAllButton = styled.button`
    background: #dc2626;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    
    &:hover {
        background: #b91c1c;
        transform: translateY(-1px);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    @media (max-width: 768px) {
        padding: 5px 10px;
        font-size: 11px;
    }
`;

// 개별 삭제 버튼
export const DeleteLogButton = styled.button`
    background: #dc2626;
    color: white;
    border: none;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    transition: all 0.2s ease;
    margin-left: 10px;
    flex-shrink: 0;
    
    &:hover {
        background: #b91c1c;
        transform: translateY(-1px);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    @media (max-width: 768px) {
        padding: 3px 6px;
        font-size: 10px;
        margin-left: 8px;
    }
`;

// 실패 로그 정보 컨테이너
export const FailedLogInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

// 실패 상세 정보 섹션
export const FailedErrorsSection = styled.div`
    padding: 16px;
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;
    margin-top: 8px;
    
    @media (max-width: 768px) {
        padding: 12px;
    }
`;

// 실패 상세 정보 목록
export const FailedErrorsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    
    @media (max-width: 768px) {
        gap: 6px;
    }
`;

// 실패 상세 정보 아이템
export const FailedErrorItem = styled.div`
    padding: 8px 12px;
    background-color: #ffffff;
    border: 1px solid #fecaca;
    border-radius: 6px;
    
    @media (max-width: 768px) {
        padding: 6px 10px;
    }
`;

// 실패 상세 정보 콘텐츠
export const FailedErrorContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    
    @media (max-width: 768px) {
        gap: 8px;
    }
`;

// 실패 메시지
export const FailedErrorMessage = styled.div`
    font-size: 12px;
    color: #374151;
    line-height: 1.4;
    flex: 1;
    min-width: 0;
    
    @media (max-width: 768px) {
        font-size: 11px;
    }
`;

// 실패 시간
export const FailedTime = styled.span`
    font-size: 11px;
    color: #9ca3af;
    white-space: nowrap;
    margin-top: 2px;
    
    @media (max-width: 768px) {
        font-size: 10px;
    }
`;

export const ViewOrderButton = styled.button`
    background-color: #3b82f6;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    cursor: pointer;
    border: none;
    &:hover {
        background-color: #2563eb;
    }
`;

// 실패한 행 스타일링
export const FailedRowStyle = styled.tr`
    &.failed-row {
        background-color: #fef2f2 !important;
        border-left: 4px solid #dc2626 !important;
        
        &:hover {
            background-color: #fee2e2 !important;
        }
        
        td {
            color: #dc2626 !important;
            font-weight: 500;
        }
    }
`;

// 달력 범례 스타일
export const CalendarLegend = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  
  @media (max-width: 768px) {
    gap: 12px;
    flex-wrap: wrap;
  }
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 12px;
    gap: 4px;
  }
`;

export const LegendColor = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  flex-shrink: 0;
  
  &.oxygen {
    background: #3b82f6;
  }
  
  &.diabetes {
    background: #7b1fa2;
  }
  
  &.expired {
    background: #c62828;
  }
  
  @media (max-width: 768px) {
    width: 14px;
    height: 14px;
  }
`;

// 툴팁 관련 스타일
export const CalendarTooltip = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 250px;
  max-width: 350px;
  pointer-events: none;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    min-width: 200px;
    max-width: 280px;
    padding: 8px;
    font-size: 12px;
  }
`;

export const TooltipTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
`;

export const TooltipEventList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
`;

export const TooltipEventItem = styled.div`
  padding: 8px;
  border-radius: 6px;
  background: #f9fafb;

  &.oxygen {
    border-left: 3px solid #3b82f6;
  }

  &.diabetes {
    border-left: 3px solid #7b1fa2;
  }

  &.expired {
    border-left: 3px solid #c62828;
  }
`;

export const TooltipEventTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
`;

export const TooltipEventDesc = styled.div`
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
`;

// 빈 상태 표시 스타일
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  border: 2px dashed #e2e8f0;
  min-height: 300px;
  
  @media (max-width: 1400px) {
    padding: 50px 20px;
    min-height: 250px;
  }
  
  @media (max-width: 768px) {
    padding: 40px 16px;
    min-height: 200px;
  }
  
  @media (max-width: 480px) {
    padding: 30px 12px;
    min-height: 180px;
  }
`;

export const EmptyIcon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.7;
  animation: float 3s ease-in-out infinite;
  
  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
  
  @media (max-width: 1400px) {
    font-size: 56px;
    margin-bottom: 18px;
  }
  
  @media (max-width: 768px) {
    font-size: 48px;
    margin-bottom: 16px;
  }
  
  @media (max-width: 480px) {
    font-size: 40px;
    margin-bottom: 14px;
  }
`;

export const EmptyTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #4a5568;
  margin: 0 0 12px 0;
  text-align: center;
  
  @media (max-width: 1400px) {
    font-size: 18px;
    margin-bottom: 10px;
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 8px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 6px;
  }
`;

export const EmptyDescription = styled.p`
  font-size: 16px;
  color: #718096;
  margin: 0;
  line-height: 1.6;
  text-align: center;
  max-width: 400px;
  
  @media (max-width: 1400px) {
    font-size: 15px;
    max-width: 360px;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 300px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    max-width: 260px;
    line-height: 1.5;
  }
`;